module.exports = __webpack_public_path__ + "static/media/school-bench-alt.6767ed8e.svg";